import React from 'react';
import { Text, TouchableOpacity, StyleSheet } from 'react-native';
import PropTypes from 'prop-types';

import Colors from '../../constants/Colors';

const LabelButton = ({ text, saveImage, textPropsStyle, containerPropsStyle, disabled }) => {
	
	const onFileChange = (event) => {
		if (event.target.files.length === 0) return;

		const file = event.target.files[0];
		let reader = new FileReader();
		
		reader.onloadend = () => {
			let base64result = reader.result.split(',')[1];
			
			saveImage(base64result);
		};

		reader.readAsDataURL(file);
	};

	return (
		<label for='invisibleInput'>
			<TouchableOpacity
				disabled={disabled === undefined ? false : disabled}
				style={[styles.container, containerPropsStyle]}
			>
				<input
					type='file'
					id='invisibleInput'
					onChange={onFileChange}
					accept='image/png, image/jpeg'
					style={{ display: 'none' }}
				/>
				
				<Text style={[styles.text, textPropsStyle]}>
					{text}
				</Text>

			</TouchableOpacity>
		</label>
	)
};

const styles = StyleSheet.create({
    container: {
        padding: 12,
        justifyContent: 'center',
        height: 60,
        alignSelf: 'stretch',
        backgroundColor: Colors.mainColor,
        borderRadius: 10,
        borderWidth: 1,
        borderColor: Colors.mainColor,
    },
    text: {
    	fontSize: 14,
    	fontWeight: 'bold',
    	color: Colors.editorButton,
    	alignSelf: 'center',
    },
});

LabelButton.propTypes = {
	saveImage: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    textPropsStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    containerPropsStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    disabled: PropTypes.bool,
};

export { LabelButton };